import { render } from "./ControlAutocomplete.vue?vue&type=template&id=59af992c&ts=true&lang=pug"
import script from "./ControlAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlAutocomplete.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__